import api from '../../../services/api';
import { AnswerKeyFormRequestProps } from '../types/template.type';

export async function editAnswerKeyRequest(data: AnswerKeyFormRequestProps[]) {
	const response = await api.put('/template', data);

	return response.data;
}
